"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CounterMenu;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _KeyboardArrowDown = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowDown"));
var _Add = _interopRequireDefault(require("@material-ui/icons/Add"));
var _Remove = _interopRequireDefault(require("@material-ui/icons/Remove"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Button = _interopRequireDefault(require("../Button"));
var _index = _interopRequireDefault(require("./index.style"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function CounterMenu(_ref) {
  let {
    lowLimit = 2,
    defaultValue = 2,
    highLimit = 4,
    typeLabel = 'Roundtrip',
    singleLabel = 'Passenger',
    multipleLabel = 'Passengers',
    cancelLabel = 'Cancel',
    doneLabel = 'Done',
    showButtons = true,
    handleCount = () => {},
    className,
    ...others
  } = _ref;
  const [counter, setCounter] = (0, _react.useState)(defaultValue);
  const [anchorEl, setAnchorEl] = (0, _react.useState)(null);
  const [initialCount, setInitialCount] = (0, _react.useState)('');
  const open = Boolean(anchorEl);
  const classes = (0, _index.default)();
  const handleMenu = event => {
    setInitialCount(counter);
    setAnchorEl(event.currentTarget);
  };
  const handleDone = () => {
    setAnchorEl(null);
    handleCount(counter);
  };
  const handleCancel = () => {
    setCounter(initialCount);
    handleCount(initialCount);
    setAnchorEl(null);
  };
  (0, _react.useEffect)(() => {
    handleCount(counter);
  }, [counter, handleCount]);
  return /*#__PURE__*/_react.default.createElement(_core.Box, (0, _extends2.default)({
    className: (0, _clsx.default)(classes.counterMenu, className)
  }, others), /*#__PURE__*/_react.default.createElement(_core.FormLabel, null, typeLabel), /*#__PURE__*/_react.default.createElement(_Button.default, {
    disableRipple: true,
    id: "counter-menu-button",
    "aria-controls": "simple-menu",
    "aria-haspopup": "true",
    "aria-expanded": open ? 'true' : undefined,
    className: classes.dropLabel,
    onClick: handleMenu
  }, counter, counter === 1 ? " ".concat(singleLabel) : " ".concat(multipleLabel), " ", /*#__PURE__*/_react.default.createElement(_KeyboardArrowDown.default, null)), /*#__PURE__*/_react.default.createElement(_core.Menu, {
    id: "simple-menu",
    "data-testid": "counter-menu",
    "aria-labelledby": "counter-menu-button",
    classes: {
      paper: classes.paper
    },
    anchorEl: anchorEl,
    keepMounted: true,
    anchorOrigin: {
      vertical: 'top',
      horizontal: 180
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'center'
    },
    open: open,
    onClose: handleCancel
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: classes.menu
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: classes.wrapperCounter
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "body1"
  }, multipleLabel), /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: classes.counter
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    disabled: counter === lowLimit,
    classes: {
      disabled: classes.disabledButton
    },
    onClick: () => setCounter(counter - 1)
  }, /*#__PURE__*/_react.default.createElement(_Remove.default, null)), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    component: "span"
  }, counter), /*#__PURE__*/_react.default.createElement(_Button.default, {
    disabled: counter === highLimit,
    classes: {
      disabled: classes.disabledButton
    },
    onClick: () => setCounter(counter + 1)
  }, /*#__PURE__*/_react.default.createElement(_Add.default, null)))), showButtons && /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: classes.footerMenu
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "text",
    onClick: handleCancel
  }, cancelLabel), /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "contained",
    color: "primary",
    className: classes.primaryButton,
    onClick: handleDone
  }, doneLabel)))));
}